(function () {
  if (window.__evolaCroInit) return;
  window.__evolaCroInit = true;

  /* EVOLA - Teklif gorunurlugu
     1) HER urun sayfasi: sepete ekle dugmesinin altinda ikili paket seridi.
        Her urunun kendi mantikli esi var, esi yoksa Lip Serum'a duser.
     2) Her sepete eklemede tema cekmecesini acar (temada auto-open yok).
     3) Sepette urun sayisi TEKIL ise (1,3,5...) hediye urununu one cikarir
        ve Ucretsiz ekle dugmesi verir.

     ONEMLI: Shopify BXGY'de bedava gelen sepetteki EN UCUZ urundur.
     Bu yuzden serit, iki urunden hangisi ucuzsa onu hediye olarak etiketler.
     Es urun daha pahaliysa bedava gelen sey mevcut urun olur ve metin ona
     gore degisir. Boylece ekranda yazan sey sepette olanla ayni kalir. */

  var GRUP = 2;
  var STYLE_ID = 'evola-cro-styles';
  var SEPET_KAP = '.cart__summary-inner, .cart-drawer__summary, .cart__summary-container';
  var BAYRAK = 'evo-cekmece-ac';

  var VARSAYILAN = 'hydrating-lip-serum';
  var YEDEK = 'brow-wax';

  /* Urun -> mantikli es. Listede olmayan her urun VARSAYILAN'a duser. */
  var ESLESME = {
    'brow-wax': 'hydrating-lip-serum',
    'pureglam': 'brow-wax',
    'hydrating-lip-serum': 'brow-wax',
    'skin-tint': 'hydrating-lip-serum',
    'sunkissed': 'skin-tint',
    'lashmetal': 'brow-wax',
    'lip-stain': 'hydrating-lip-serum'
  };

  var CSS = [
    '.evo-blok{border:1px solid var(--color-border,#E5DCD1);border-radius:2px;background:rgba(0,0,0,.02);padding:14px 16px;margin-block:14px;font-family:Helvetica,Arial,sans-serif;color:var(--color-foreground,#3A342E);width:100%;box-sizing:border-box;}',
    '.evo-blok__ust{font-size:0.6875rem;letter-spacing:0.14em;text-transform:uppercase;opacity:.65;margin:0 0 10px;}',
    '.evo-hediye{display:flex;align-items:center;gap:12px;}',
    '.evo-hediye--vurgu{margin-block-start:12px;padding-block-start:12px;border-top:1px solid var(--color-border,#E5DCD1);}',
    '.evo-hediye__gorsel{width:52px;height:52px;flex:0 0 52px;border-radius:2px;object-fit:cover;border:1px solid var(--color-border,#E5DCD1);}',
    '.evo-hediye__govde{flex:1 1 auto;min-width:0;}',
    '.evo-hediye__ad{font-size:0.875rem;line-height:1.35;margin:0 0 3px;}',
    '.evo-hediye__fiyat{font-size:0.8125rem;opacity:.7;margin:0;}',
    '.evo-hediye__rozet{display:inline-block;font-size:0.625rem;letter-spacing:0.1em;text-transform:uppercase;color:#fff;background:#8A8077;padding:2px 7px;border-radius:2px;margin-inline-start:6px;vertical-align:middle;}',
    '.evo-dugme{display:block;width:100%;margin-block-start:12px;padding:13px 16px;border:0;border-radius:2px;background:#8A8077;color:#fff;font-family:inherit;font-size:0.8125rem;letter-spacing:0.08em;text-transform:uppercase;cursor:pointer;}',
    '.evo-dugme:hover{opacity:.88;}',
    '.evo-dugme[disabled]{opacity:.5;cursor:default;}',
    '.evo-cubuk{position:relative;height:3px;border-radius:2px;background:var(--color-border,#E5DCD1);overflow:hidden;margin-block-start:10px;}',
    '.evo-cubuk__dolu{position:absolute;inset-block:0;inset-inline-start:0;background:#8A8077;transition:width .35s ease;}',
    '.evo-mesaj{font-size:0.875rem;line-height:1.5;margin:0;}',
    '.evo-mesaj b{font-weight:600;}',
    '.evo-alt{font-size:0.75rem;line-height:1.5;opacity:.65;margin:9px 0 0;}',
    '.evo-blok--acik{border-color:#8A8077;}'
  ].join('');

  function stilEkle() {
    if (document.getElementById(STYLE_ID)) return;
    var s = document.createElement('style');
    s.id = STYLE_ID;
    s.textContent = CSS;
    (document.head || document.documentElement).appendChild(s);
  }

  function para(kurus) {
    try {
      return new Intl.NumberFormat('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(kurus / 100) + ' TL';
    } catch (e) {
      return (kurus / 100).toFixed(2) + ' TL';
    }
  }

  function ilkVar(secililer) {
    for (var i = 0; i < secililer.length; i++) {
      var n = document.querySelector(secililer[i]);
      if (n) return n;
    }
    return null;
  }

  function sepetSayfasiMi() {
    return /\/cart(\/|$|\?)/.test(window.location.pathname + window.location.search);
  }

  function sepeteEkle(varyantId) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(varyantId), quantity: 1 }] })
    }).then(function (r) { return r.json(); });
  }

  function cekmece() { return document.querySelector('cart-drawer-component'); }

  function cekmeceAcikMi() {
    var c = cekmece();
    if (!c) return false;
    var dlg = c.querySelector('dialog');
    if (dlg) return dlg.hasAttribute('open');
    return c.hasAttribute('open');
  }

  function cekmeceyiAc() {
    var c = cekmece();
    if (c && typeof c.open === 'function') {
      try { c.open(); return true; } catch (e) {}
    }
    return false;
  }

  function acilisIstegiBirak() {
    try { sessionStorage.setItem(BAYRAK, '1'); } catch (e) {}
  }

  function acilisIstegiVarMi() {
    try {
      if (sessionStorage.getItem(BAYRAK) === '1') {
        sessionStorage.removeItem(BAYRAK);
        return true;
      }
    } catch (e) {}
    return false;
  }

  /* ---------- Urun onbellegi ---------- */

  var urunOnbellek = {};
  var hediyeUrun = null;

  function urunGetir(handle) {
    if (!handle) return Promise.resolve(null);
    if (urunOnbellek[handle]) return Promise.resolve(urunOnbellek[handle]);
    return fetch('/products/' + handle + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (u) { if (u) urunOnbellek[handle] = u; return u; })
      .catch(function () { return null; });
  }

  /* Aday listesindeki ilk stokta olan urunu dondurur. */
  function ilkUygun(adaylar, mevcutHandle) {
    var i = 0;
    function dene() {
      if (i >= adaylar.length) return Promise.resolve(null);
      var h = adaylar[i++];
      if (!h || h === mevcutHandle) return dene();
      return urunGetir(h).then(function (u) {
        return (u && u.available) ? u : dene();
      });
    }
    return dene();
  }

  /* ---------- 1. URUN SAYFASI: ikili paket seridi ---------- */

  function mevcutHandle() {
    var m = window.location.pathname.match(/\/products\/([^/?#]+)/);
    return m ? m[1] : null;
  }

  function urunFormu() {
    return ilkVar(['product-form-component form[action*="/cart/add"]', 'form[action*="/cart/add"]']);
  }

  function anaSepetDugmesi() {
    var f = urunFormu();
    if (!f) return null;
    return f.querySelector('[ref="addToCartButton"]') || f.querySelector('button[type="submit"]');
  }

  function seciliVaryant() {
    var f = urunFormu();
    if (!f) return null;
    var i = f.querySelector('[name="id"]');
    return i && i.value ? i.value : null;
  }

  function seritCiz() {
    var handle = mevcutHandle();
    if (!handle) return;

    var yuva = ilkVar(['.buy-buttons-block', 'product-form-component', 'form[action*="/cart/add"]']);
    if (!yuva) return;

    var kap = yuva.parentNode;
    if (!kap || kap.querySelector(':scope > .evo-blok--urun')) return;

    var adaylar = [ESLESME[handle], VARSAYILAN, YEDEK];

    Promise.all([urunGetir(handle), ilkUygun(adaylar, handle)]).then(function (sonuc) {
      var mevcut = sonuc[0];
      var es = sonuc[1];
      if (!es) return;
      if (kap.querySelector(':scope > .evo-blok--urun')) return;

      var gorsel = es.featured_image || (es.images && es.images[0]) || '';

      /* Bedava gelen, iki urunden ucuz olandir. Metni ona gore kur. */
      var mevcutFiyat = mevcut ? mevcut.price : null;
      var esUcuz = (mevcutFiyat === null) || (es.price <= mevcutFiyat);

      var fiyatSatiri = esUcuz
        ? '<s>' + para(es.price) + '</s> · sepette ücretsiz'
        : para(es.price) + ' · ekleyince bu sayfadaki ürün ücretsiz gelir';

      var rozet = esUcuz ? '<span class="evo-hediye__rozet">Hediye</span>' : '';

      var blok = document.createElement('div');
      blok.className = 'evo-blok evo-blok--urun';
      blok.innerHTML =
        '<p class="evo-blok__ust">Seçtiğin 2. ürün hediye</p>' +
        '<div class="evo-hediye">' +
        (gorsel ? '<img class="evo-hediye__gorsel" src="' + gorsel + '" alt="" loading="lazy">' : '') +
        '<div class="evo-hediye__govde">' +
        '<p class="evo-hediye__ad">' + es.title + rozet + '</p>' +
        '<p class="evo-hediye__fiyat">' + fiyatSatiri + '</p>' +
        '</div></div>' +
        '<button type="button" class="evo-dugme" data-evo-ekle>İkisini birden sepete ekle</button>' +
        '<p class="evo-alt">İndirim sepette otomatik uygulanır. Kupon veya kod gerekmez.</p>';

      kap.insertBefore(blok, yuva.nextSibling);

      blok.querySelector('[data-evo-ekle]').addEventListener('click', function (e) {
        var dugme = e.currentTarget;
        var eskiYazi = dugme.textContent;
        dugme.disabled = true;
        dugme.textContent = 'Ekleniyor...';

        function bitir() {
          setTimeout(function () {
            dugme.disabled = false;
            dugme.textContent = eskiYazi;
          }, 1200);
        }

        sepeteEkle(es.variants[0].id)
          .then(function () {
            var anaDugme = anaSepetDugmesi();
            if (anaDugme && !anaDugme.disabled) {
              anaDugme.dataset.puppet = 'true';
              anaDugme.click();
              bitir();
              return;
            }
            var vid = seciliVaryant();
            if (!vid) {
              if (!cekmeceyiAc()) { acilisIstegiBirak(); window.location.reload(); }
              bitir();
              return;
            }
            return sepeteEkle(vid).then(function () {
              if (!cekmeceyiAc()) { acilisIstegiBirak(); window.location.reload(); }
              bitir();
            });
          })
          .catch(function () {
            dugme.disabled = false;
            dugme.textContent = eskiYazi;
          });
      });
    });
  }

  /* ---------- 2. SEPET ---------- */

  function durum(sepet) {
    var adet = sepet.item_count || 0;
    if (adet < 1) return null;

    var bedava = Math.floor(adet / GRUP);
    var eksik = (adet % GRUP) === 0 ? 0 : GRUP - (adet % GRUP);
    var oran = eksik === 0 ? 1 : (adet % GRUP) / GRUP;
    var indirim = sepet.total_discount || 0;

    var mesaj, alt;
    if (bedava === 0) {
      mesaj = '<b>1 ürün daha ekle</b>, ikincisi hediye.';
      alt = 'Teklif tüm koleksiyonda geçerli. Hediye, sepetteki en uygun fiyatlı üründür.';
    } else if (eksik === 0) {
      mesaj = '<b>İkinci ürün hediye uygulandı.</b> ' + bedava + ' ürün ücretsiz.';
      alt = indirim > 0 ? 'Kazancınız: ' + para(indirim) : 'İndirim ödeme adımında görünür.';
    } else {
      mesaj = '<b>' + bedava + ' ürün hediye.</b> 1 ürün daha ekle, bir tane daha hediye.';
      alt = indirim > 0 ? 'Şu ana kadar kazancınız: ' + para(indirim) : 'İndirim ödeme adımında görünür.';
    }

    return { mesaj: mesaj, alt: alt, oran: oran, eksik: eksik, acik: bedava > 0, imza: adet + ':' + indirim + ':' + (hediyeUrun ? '1' : '0') };
  }

  function hediyeKarti() {
    if (!hediyeUrun) return '';
    var gorsel = hediyeUrun.featured_image || (hediyeUrun.images && hediyeUrun.images[0]) || '';
    return '<div class="evo-hediye evo-hediye--vurgu">' +
      (gorsel ? '<img class="evo-hediye__gorsel" src="' + gorsel + '" alt="" loading="lazy">' : '') +
      '<div class="evo-hediye__govde">' +
      '<p class="evo-hediye__ad">' + hediyeUrun.title + '<span class="evo-hediye__rozet">Hediye</span></p>' +
      '<p class="evo-hediye__fiyat"><s>' + para(hediyeUrun.price) + '</s> · bu ürünü ekleyince ücretsiz gelir</p>' +
      '</div></div>' +
      '<button type="button" class="evo-dugme" data-evo-bedava>Ücretsiz ekle</button>';
  }

  function sepetCiz(sepet) {
    var d = durum(sepet);
    var kaplar = document.querySelectorAll(SEPET_KAP);

    if (!d) {
      document.querySelectorAll('.evo-blok--sepet').forEach(function (n) { n.remove(); });
      return;
    }

    kaplar.forEach(function (kap) {
      var kutu = kap.querySelector(':scope > .evo-blok--sepet');
      if (!kutu) {
        kutu = document.createElement('div');
        kutu.className = 'evo-blok evo-blok--sepet';
        kap.insertBefore(kutu, kap.firstChild);
      }

      if (kutu.getAttribute('data-imza') === d.imza) return;

      kutu.className = 'evo-blok evo-blok--sepet' + (d.acik ? ' evo-blok--acik' : '');
      kutu.innerHTML =
        '<p class="evo-blok__ust">Seçtiğin 2. ürün hediye</p>' +
        '<p class="evo-mesaj">' + d.mesaj + '</p>' +
        '<div class="evo-cubuk"><span class="evo-cubuk__dolu" style="width:' + Math.round(d.oran * 100) + '%"></span></div>' +
        '<p class="evo-alt">' + d.alt + '</p>' +
        (d.eksik > 0 ? hediyeKarti() : '');
      kutu.setAttribute('data-imza', d.imza);
    });
  }

  document.addEventListener('click', function (e) {
    var dugme = e.target && e.target.closest ? e.target.closest('[data-evo-bedava]') : null;
    if (!dugme || !hediyeUrun) return;
    e.preventDefault();
    if (dugme.disabled) return;
    dugme.disabled = true;
    var eski = dugme.textContent;
    dugme.textContent = 'Ekleniyor...';
    sepeteEkle(hediyeUrun.variants[0].id)
      .then(function () {
        if (!sepetSayfasiMi()) acilisIstegiBirak();
        window.location.reload();
      })
      .catch(function () {
        dugme.disabled = false;
        dugme.textContent = eski;
      });
  });

  var sonZaman = 0;

  function tara() {
    stilEkle();
    seritCiz();

    if (!document.querySelector(SEPET_KAP)) return;

    var simdi = (window.performance && performance.now) ? performance.now() : 0;
    if (simdi - sonZaman < 400) return;
    sonZaman = simdi;

    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(sepetCiz)
      .catch(function () {});
  }

  function baslat() {
    urunGetir(VARSAYILAN).then(function (u) {
      if (u && u.available) { hediyeUrun = u; sonZaman = 0; tara(); }
    });
    tara();
    if (acilisIstegiVarMi()) {
      setTimeout(function () { if (!cekmeceAcikMi()) cekmeceyiAc(); }, 500);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', baslat);
  } else {
    baslat();
  }

  if (window.MutationObserver) {
    var mo = new MutationObserver(function () {
      clearTimeout(window.__evolaTara);
      window.__evolaTara = setTimeout(tara, 80);
    });
    mo.observe(document.documentElement, { childList: true, subtree: true });
  }

  document.addEventListener('cart:update', function (e) {
    sonZaman = 0;
    setTimeout(tara, 120);
    try {
      var d = (e && e.detail && e.detail.data) ? e.detail.data : {};
      if (d.source === 'evola-cro') return;
      if (sepetSayfasiMi()) return;
      if (typeof d.itemCount === 'number' && d.itemCount <= 0) return;
      setTimeout(function () { if (!cekmeceAcikMi()) cekmeceyiAc(); }, 260);
    } catch (hata) {}
  });
})();
